import {
  LIST_GENERAL_CONFIGURATION_REQUEST,
  LIST_GENERAL_CONFIGURATION_SUCCESS,
  LIST_GENERAL_CONFIGURATION_FAIL,
  PATCH_GENERAL_CONFIGURATION_REQUEST,
  PATCH_GENERAL_CONFIGURATION_SUCCESS,
  PATCH_GENERAL_CONFIGURATION_FAIL,
  DETAIL_GENERAL_CONFIGURATION_REQUEST,
  DETAIL_GENERAL_CONFIGURATION_SUCCESS,
  DETAIL_GENERAL_CONFIGURATION_FAIL
} from '../../constants/general-configuration'

const initialState = {
  loadingGeneralConfiguration: false,
  loadingDetailGeneralConfiguration: false,
  loadingPatchGeneralConfiguration: false,
  generalConfigurations: [],
  generalConfiguration: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listGeneralConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_GENERAL_CONFIGURATION_REQUEST:
      return { ...state, loadingGeneralConfiguration: true }
    case LIST_GENERAL_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingGeneralConfiguration: false,
        generalConfigurations: action.payload,
        pageable: action.pageable
      }
    case LIST_GENERAL_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingGeneralConfiguration: false,
        error: action.payload
      }
    case PATCH_GENERAL_CONFIGURATION_REQUEST:
      return { ...state, loadingPatchGeneralConfiguration: true }
    case PATCH_GENERAL_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingPatchGeneralConfiguration: false,
        GeneralConfigurationDetail: action.payload,
        pageable: action.pageable
      }
    case PATCH_GENERAL_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingPatchGeneralConfiguration: false,
        error: action.payload
      }
    case DETAIL_GENERAL_CONFIGURATION_REQUEST:
      return {
        ...state,
        loadingDetailGeneralConfiguration: true,
        error: null,
        generalConfiguration: {}
      }
    case DETAIL_GENERAL_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingDetailGeneralConfiguration: false,
        generalConfiguration: action.payload,
        error: null
      }
    case DETAIL_GENERAL_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingDetailGeneralConfiguration: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default listGeneralConfigurationReducer
